// extracted by mini-css-extract-plugin
export default {"side_share_box":"index_side_share_box_Y-OOo"};